<template>
    <div class="chat-container">
      <div class="left">
        <ul class="people">
          <li class="person" @click="selectChat(group, key)" v-for="(group, key) in chat.groups" :key="key" :data-chat="key">
            <img :src="group.groupImage" alt="" />
            <span class="name">{{ group.name.slice(0,15) }}</span>
            <span class="time" v-if="group.data.length > 0">{{ group.data[0].time.split(" ")[1].slice(0,-3) }}</span>
            <span class="preview" v-if="group.data.length > 0"><b v-if="!group.data[group.data.length-1].sender">{{group.member[group.data[group.data.length-1].from].name}}</b><b v-if="group.data[group.data.length-1].sender">Du</b> {{ group.data[group.data.length-1].message }}</span>
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="top"><b><span class="name">{{ selectedChat.name }}</span></b></div>
        <div v-for="(msg, indx) in selectedChat.data" :key="indx" :class="[msg.from === 1001 ? 'systeminfo' :'bubble', msg.sender ? 'me' : 'you']">
          <img v-show="showProfile(indx)" :src="selectedChat.member[msg.from].profilePicture" alt="" />
          <b v-show="showProfile(indx)" v-if="msg.sender">Du</b>
          <b v-show="showProfile(indx) && msg.from !== 1001" v-if="!msg.sender">{{ selectedChat.member[msg.from].name }}</b>
          <br>
          <b v-show="msg.from === 1001">System: </b>
          {{ msg.message }}
          <br>
          <span class="timestamp">{{ msg.time.split(" ")[1].slice(0,-3) }}</span>
        </div>
        <b-form class="messagesend" v-if="selectedChat.name" @submit.prevent="sendMessage">
          <b-input v-model="messageinput" placeholder="Nachricht eingeben..." autocomplete="off"/>
        </b-form>
      </div>
    </div>
</template>

<script>
import {messageService} from "@/services/message.service";

export default {
  name: "Messages",
  data() {
    return {
      chat: {},
      selectedChat: {},
      selectedGroupKey: "",
      messageinput: ""
    }
  },
  mounted: function () {
    window.setInterval(() => {
      messageService.getChat().then(res => {
        this.chat = res.chat
        if (Object.keys( this.selectedChat).length > 0) {
          this.selectedChat = this.chat.groups[this.selectedGroupKey]
        }
      })
    }, 30000)
  },
  created() {
    messageService.getChat().then(res => {
      this.chat = res.chat
    })
  },
  methods: {
    selectChat(group, gkey) {
      this.selectedChat = group
      this.selectedGroupKey = gkey
    },
    showProfile(indx) {
      if(indx <= 0) {
        return true
      }
      if (this.selectedChat.data[indx].from === "1001") {
        return false
      }
      return this.selectedChat.data[indx].from !== this.selectedChat.data[indx - 1].from;

    },
    sendMessage() {
      let message = this.messageinput
      let groupKey = this.selectedGroupKey
      let d = new Date();
      let timesplit = d.toLocaleDateString()
      let fromtime = timesplit[2] + "-" + timesplit[1] + "-" + timesplit[0] + " " + d.toLocaleTimeString()
      messageService.sendMessage(message, groupKey, true).then(res => {
        if (res.code === 1) {
          this.messageinput = ""
          let element = {
            "message": message,
            "sender": true,
            "from": this.chat.friendCode,
            "time": fromtime
          }
          this.chat.groups[groupKey].data.push(element)
        } else {
          this.$root.$bvToast.toast(res.message, {
            title: "Fehler beim senden",
            autoHideDelay: 5000,
            variant: "danger"
          });
        }
      })
    }
  }
}
</script>

<style scoped>
  .chat-container {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 40px;
    height: 90vh;
  }
  .chat-container .left .people {
    margin-left: -1px;
    border-right: 1px solid var(--light);
    border-left: 1px solid var(--light);
    width: calc(100% + 2px);
    list-style: none;
  }
  .chat-container .left .people .person {
    position: relative;
    width: 100%;
    padding: 12px 10% 16px;
    cursor: pointer;
    background-color: var(--white);
  }
  .chat-container .left .people .person:after {
    position: absolute;
    bottom: 0;
    left: 50%;
    display: block;
    width: 80%;
    height: 1px;
    content: '';
    background-color: var(--light);
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
  }
  .chat-container .left .people .person img {
    float: left;
    width: 40px;
    height: 40px;
    margin-right: 12px;
    border-radius: 50%;
    -o-object-fit: cover;
    object-fit: cover;
  }
  .chat-container .left .people .person .name {
    font-size: 14px;
    line-height: 22px;
    color: var(--dark);
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
  }
  .chat-container .left .people .person .time {
    font-size: 14px;
    position: absolute;
    top: 16px;
    right: 10%;
    padding: 0 0 5px 5px;
    color: #555;
    background-color: var(--white);
  }
  .chat-container .left .people .person .preview {
    font-size: 14px;
    display: inline-block;
    overflow: hidden !important;
    width: 70%;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #555;
  }
  .chat-container .left .people .person.active, .container .left .people .person:hover {
    margin-top: -1px;
    margin-left: -1px;
    padding-top: 13px;
    border: 0;
    background-color: var(--blue);
    width: calc(100% + 2px);
    padding-left: calc(10% + 1px);
  }
  .chat-container .left .people .person.active span, .container .left .people .person:hover span {
    color: var(--white);
    background: transparent;
  }
  .chat-container .left .people .person.active:after, .container .left .people .person:hover:after {
    display: none;
  }
  .chat-container .right {
    height: 100%;
    position: relative;
  }
  .container .right .top {
    width: 100%;
    height: 47px;
    margin-bottom: 40px;
    padding: 15px 29px;
    background-color: #eceff1;
  }
  .container .right .top span {
    font-size: 15px;
    color: #555;
  }
  .container .right .top span .name {
    color: var(--dark);
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
  }
  .chat-container .right .bubble {
    font-size: 16px;
    position: relative;
    display: inline-block;
    clear: both;
    max-width: 300px;
    width: 100%;
    margin-bottom: 8px;
    padding: 13px 14px 38px;
    vertical-align: top;
    border-radius: 5px;
  }
  .chat-container .right .bubble:before {
    position: absolute;
    top: 19px;
    display: block;
    width: 8px;
    height: 6px;
    content: '\00a0';
    -webkit-transform: rotate(29deg) skew(-35deg);
    transform: rotate(29deg) skew(-35deg);
  }
  .chat-container .right .systeminfo {
    font-size: 16px;
    position: relative;
    display: inline-block;
    clear: both;
    width: 100%;
    margin-bottom: 40px;
  }
  .chat-container .right .systeminfo .timestamp {
    margin-right: 12px;
    position: absolute;
    right: 0;
    top: 50%;
    height: 25px;
  }
  .chat-container .right .bubble img {
    width: 50px;
    height: 50px;
    margin-right: 12px;
    border-radius: 50%;
    position: absolute;
    right: -20px;
    top: -20px;
    border: 2px solid #333333;
    -o-object-fit: cover;
    object-fit: cover;
  }
  .chat-container .right .bubble .timestamp {
    margin-right: 12px;
    position: absolute;
    right: 0;
    bottom: 0;
    height: 25px;
  }
  .chat-container .right .bubble.you {
    float: left;
    color: var(--white);
    background-color: var(--blue);
    align-self: flex-start;
    -webkit-animation-name: slideFromLeft;
    animation-name: slideFromLeft;
  }
  .chat-container .right .bubble.you:before {
    left: -3px;
    background-color: var(--blue);
  }
  .chat-container .right .bubble.me {
    float: right;
    color: var(--dark);
    background-color: #eceff1;
    align-self: flex-end;
    -webkit-animation-name: slideFromRight;
    animation-name: slideFromRight;
  }
  .chat-container .right .bubble.me:before {
    right: -3px;
    background-color: #eceff1;
  }
  .chat-container .right .messagesend{
    position: absolute;
    bottom: 0;
    width: 100%;
  }
</style>